<template>
	<div class="d-none d-lg-block col-auto volume-container">
		<datalist v-if="initialOffset != undefined" :id="datalistID"><option>{{ sliderNotchVal }}</option><option>1</option></datalist>
		<input class="volume-slider" type="range" min="0" max="2"
			@input="onInput"
			@change="storeVolume"
			@click="onClick"
			:value="sliderValue"
			:step="sliderStep"
			:list="datalistID">
		<div class="volume-text">{{ volumeText }}</div>
	</div>
</template>
<style scoped>
.volume-text {
  color: #111;
}

.volume-container {
  width: 30px;
}

.volume-slider {
   position: relative;
   transform: rotate(270deg);
   top: 35px;
   left: -20px;
   width: 70px;
   z-index: 1
 }

 .volume-offset-marker {
  position: absolute;
  height: 2px;
  width: 20px;
  margin-left: -5px;
  background-color: black;
  z-index: 0
 }

.volume-text {
  position: absolute;
  bottom: 0px;
  left: 0px;
  font-size: 10px;
  font-family: monospace;
}


</style>

<script>

import Gain from './volume_gain.js'
import fetch_csrf from '../utils/csrf'

export default {
	props: ["initial-volume", "initial-offset", "mixID"],

	data() {
		const gain = new Gain(parseFloat(this.initialVolume) || 0)
		this.$emit('input', gain.toGainValue())

		return {
			gain: gain,
			sliderStep: 0.01
		}
	},
	watch: {
		gain() {
			this.$emit('input', this.gain.toGainValue())
		},
		initialOffset() {
			if ( this.initialVolume == undefined ) {
				this.gain = new Gain(this.initialOffset || 0)
			}
		}
	},
	methods: {
		onInput(ev) {
			this.gain = Gain.fromSliderValue(parseFloat(ev.target.value))
			this.$emit("input", this.gain.toGainValue())
		},
		onClick(ev) {
      if ( ev.altKey ) {
        this.gain = new Gain(0);
				this.$emit("input", this.gain.toGainValue())
      }
		},
		storeVolume() {
			fetch_csrf('/mixes/' + this.mixID, {
				method: "put",
				body: JSON.stringify({volume: this.gain.dbs}),
				headers: {
					'Content-type': 'application/json'
				}
			})
		}
	},
	computed: {
		offset() {
			return new Gain(this.initialOffset)
		},
		sliderValue() {
			return this.gain.toSliderValue()
		},
		sliderNotchVal() {
			return this.sliderStep* Math.floor(this.offset.toSliderValue() / this.sliderStep);
		},
		datalistID() {
			return `notch-${this.mixID}`
		},
		volumeText() {
			const gain = this.gain.dbs
			let dbStr = "";

			if ( gain == "-Infinity" )
				dbStr = "-∞db";
			else {
				if ( gain > 0 )
					dbStr += "+";

				if ( gain.toFixed )
					dbStr += gain.toFixed(1);
				else
					dbStr += gain

				dbStr += "db";
			}
			return dbStr
		}
	}
}
</script>
